module.exports = __webpack_public_path__ + "media/application/images/svgs/plus-square-572c4d34991a7f6ab710268dc0d1ceb6.svg";